<template>
  <section class="section hero-section">
    <div class="wrapper">
      <div class="hero-content">
        <img
          src="./../assets/img/heroImg.webp"
          alt="Hero Image"
          class="hero-image"
        />
        <h1 class="title big main-title text-white">
          {{ $t(`Discover CS2 Skins`) }}
        </h1>
        <p class="desc opacity-50">
          {{
            $t(
              "Looking for a rare knife, a striking AK-47, or a classic AWP look?",
            )
          }}
          <br />
          {{ $t("We’ve got it all in one place.") }}
        </p>
        <router-link
          :to="{ name: 'ProductListPage', params: { itemType: 'all' } }"
          class="button white w-170"
        >
          {{ $t(`Start shopping`) }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "HeaderComponent",
  components: {},
  emits: ["openSignIn", "openSignUp"],
  props: {
    isAuth: { type: Boolean, required: true },
    cartContents: { type: Array, required: true },
    walletBalance: { type: Number, required: true },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["currency"]),
  },
  methods: {
    ...mapActions("app", ["changeLocale", "changeCurrency"]),
    handleShopNowClick() {
      if (this.isAuth) {
        this.$router.push("/products/all");
      } else {
        this.openSignIn();
      }
    },
    openSignIn() {
      this.$emit("openSignIn");
    },
    openSignUp() {
      this.$emit("openSignUp");
    },
  },
};
</script>

<style lang="scss" scoped>
.hero-section {
  position: relative;
  padding: 60px 16px 70px;
  background-image: url("@/assets/img/hero.webp");
  background-position: top center;
  background-size: 1512px;
  background-repeat: no-repeat;

  .wrapper {
    max-width: 1012px;
    background-image: url("@/assets/img/hero2.webp");
    background-size: cover;
    border-radius: 12px;
    padding: 226px 70px 70px;
  }
}

.left-side {
  z-index: 1;
}

.desc {
  max-width: 458px;
  margin: 30px 0;
}

.hero-image {
  z-index: 0;
  position: absolute;
  left: calc(50% + 20px);
  top: -34px;
  transform: translateX(-50%);
  pointer-events: none;
  width: 1388px;
}

@media (max-width: 1200px) {
  .section.hero-section .wrapper {
    padding: 40px;
  }
  .hero-image {
    display: none;
  }
  .hero-content {
    justify-content: center;
  }
  .section .wrapper {
    padding: 50px 0;
  }
}
</style>
